module.exports = __webpack_public_path__ + "media/images/basic_logos/bargraph2-e6e2d07256f97fec29067cd79c2f500a.png";